import { useState } from 'react';
import type { Channel } from '@shared/types.ts';

/**
 * A channel's artwork, with a real fallback.
 *
 * Hiding a broken <img> leaves an empty tile — invisible on a dark theme and
 * a glaring white square on a light one. Falling back to the channel number
 * keeps the tile meaningful whatever the theme, and tells you WHICH channel
 * is missing artwork instead of just that something is.
 */
export function ChannelLogo({
  channel, className,
}: {
  channel: Pick<Channel, 'logo' | 'number' | 'name'>;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const show = channel.logo && !failed;

  return (
    <div className={className ?? 'logo'}>
      {show
        ? (
          <img
            src={channel.logo!}
            alt=""
            loading="lazy"
            onError={() => setFailed(true)}
          />
        )
        : <span className="num" title={channel.name}>{channel.number}</span>}
    </div>
  );
}
